import { DEFAULT_ASPECT_RATIO as r } from "./constants.mjs";
function n(t) {
  return t.aspectRatio || r;
}
function a(t, e) {
  return { item: t, index: e, aspectRatio: n(t) };
}
function i(t) {
  return {
    flexGrow: t,
    aspectRatio: t.toString()
  };
}
function p(t, e) {
  return `${t}px ${e}px`;
}
export {
  p as getGapStyle,
  a as getItemRenderData,
  i as getItemStyleProps,
  n as getSafeAspectRatio
};
